export enum UIControlTyp {
  DropDownList,
  MultiSelectList,
  GridSingleValueField,
  InputField,
  InputFieldReadOnly
}
